import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "15",
  cy: "15",
  r: "15",
  fill: "#FCBB2E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "15",
  cy: "15",
  r: "12.5",
  fill: "#F3A700"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.73 8.75h-3.22v12.5h3.22V8.75ZM13.238 17.148a3.986 3.986 0 0 0 3.626-4.318 3.986 3.986 0 0 0-3.626 4.318ZM12.595 8.75h-3.22v12.5h3.22V8.75Z",
  fill: "#FFE2A3"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }